<template>
  <div>
    <ResultGroup :heading="$t('search.jump_to')">
      <ResultItem
        v-for="(page, index) in popularPages"
        :key="index"
        :label="page.name"
        icon="settings"
        :routerLink="{
          path: getRoutePrefix() + page.path
        }"
        :index="index"
        @select="emit('select')"
      />
    </ResultGroup>
    <ResultGroup
      v-if="history && history.length"
      :heading="$t('search.recents')"
    >
      <ResultItem
        v-for="(historyItem, index) in history"
        :key="`history-${index}`"
        :label="historyItem.label"
        :icon="historyItem.icon"
        :routerLink="historyItem.routerLink"
        :subLabel="historyItem.subLabel"
        :index="popularPages.length + index"
        history
        @select="emit('select')"
      />
    </ResultGroup>
    <Tips v-if="!device.touch" />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { device } from '@/user-context';
import { getRoutePrefix } from './helpers';
import ResultGroup from './ResultGroup.vue';
import ResultItem from './ResultItem.vue';
import Tips from './Tips.vue';

const emit = defineEmits(['select', 'selectIndex']);

const history = inject<any>('history');
const popularPages = inject<any>('popularPages');
const selectedIndex = inject<any>('selectedIndex');

const onKeyPress = (e) => {
  if (e.key === 'ArrowDown') {
    if (
      selectedIndex.value <
      popularPages.value.length + history.value.length - 1
    ) {
      emit('selectIndex', selectedIndex.value + 1);
    }
  } else if (e.key === 'ArrowUp') {
    if (selectedIndex.value > 0) {
      emit('selectIndex', selectedIndex.value - 1);
    }
  }
};

window.addEventListener('keydown', onKeyPress);

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeyPress);
});
</script>
